const styles = {
    app: {
        fontFamily: 'Verlag A, Verlag B, aktiv-grotesk, sans-serif',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        padding: '0',
        margin: '0',
    },
    american: {
        backgroundColor: '#240900',
    },
    gold: {
        '@media (max-width: 500px)': {
            backgroundColor: '#EAD19D'
        },
    },
    dream: {},
    super: {},
};

export default styles;